import localStorage from 'store'

import linkedin from '@/api/linkedin'
import userAgent from '@/libs/user-agent'

import state from './state'

export default {
  computed: {
    isApp: function () {
      return userAgent.isApp()
    },
    isLinkedInRedirect: function () {
      return this.$route.query.state && this.$route.query.code
    }
  },
  methods: {
    handleLinkedInRedirect: function () {
      const appRedirect = localStorage.get('appRedirect')
      if (appRedirect || !this.isLoggedIn) { // if we got here and aren't logged in, assume it was a webview on the app
        localStorage.remove('appRedirect')
        const data = JSON.stringify({ code: this.$route.query.code, state: this.$route.query.state })
        window.location = `${userAgent.appURI(appRedirect)}://linkedin/${data}`
      } else {
        this.verifyLinkedInAuth(this.$route.query.code, this.$route.query.state)
      }
    },

    linkedInAuth: function () {
      linkedin.getUrl().then((response) => {
        if (response.data.result.url) {
          if (this.isApp) {
            document.addEventListener('appURLReceived', (event) => {
              if (event.detail && event.detail.path === 'linkedin') {
                if (event.detail.data && event.detail.data.code && event.detail.data.state) {
                  this.verifyLinkedInAuth(event.detail.data.code, event.detail.data.state)
                }
              }
              document.removeEventListener('appURLReceived')
            }, false)
          }

          let url = response.data.result.url
          if (this.isApp) {
            url = `${this.$webRoot}/redirect?url=${encodeURIComponent(url)}`
          }

          window.open(url, '_self')
        } else {
          this.importFromLinkedIn()
        }
      }, () => {
        // @todo handle error
      })
    },

    verifyLinkedInAuth: function (accessCode, stateKey) {
      linkedin.verify(accessCode, stateKey).then((response) => {
        this.importFromLinkedIn()
      }, () => {
        // @todo handle error
      })
    },

    importFromLinkedIn: function () {
      linkedin.getProfile().then((response) => {
        const profile = response.data.result.profile

        const data = {
          bio: profile.summary,
          location: profile.location.name,
          areaOfInterest: profile.industry,
          avatar: null
        }

        if (profile.pictureUrl) {
          data.avatar = profile.pictureUrl
        } else if (profile.pictureUrls.values && profile.pictureUrls.values.length > 0) {
          data.avatar = profile.pictureUrls.values[0]
        }

        this._set(state.importData, data)
      }, (error) => {
        // @todo handle error
        console.error(error) // temporary addition to identify error. to be removed asap
      })
    }
  }
}
